export default "__VITE_ASSET__e0fad2d5__"